import FauxImage from './FauxImage';
import FauxUnavailableImage from './FauxUnavailableImage';
import Frame from './Frame';

export default FauxImage;
export { Frame, FauxUnavailableImage };
